import { Component, inject } from '@angular/core';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  RouteConfigLoadEnd,
  RouteConfigLoadStart,
  Router,
  RouterOutlet,
} from '@angular/router';
import { PageLoaderComponent } from '../../shared/components/page-loader/page-loader.component';
import { LoadingService } from '../../shared/services/loading/loading.service';

@Component({
  selector: 'app-extranet',
  standalone: true,
  imports: [RouterOutlet, PageLoaderComponent],
  templateUrl: './extranet.component.html',
  styleUrl: './extranet.component.scss',
})
export class ExtranetComponent {
  readonly loadingService: LoadingService = inject(LoadingService);

  constructor(private readonly router: Router) {}

  ngOnInit(): void {
    this.router.events.subscribe({
      next: (event) => {
        if (
          event instanceof RouteConfigLoadStart ||
          event instanceof NavigationStart
        ) {
          this.loadingService.show();
        }

        if (
          event instanceof RouteConfigLoadEnd ||
          event instanceof NavigationEnd ||
          event instanceof NavigationCancel ||
          event instanceof NavigationError
        ) {
          this.loadingService.hide();
        }
      },
    });
  }
}
